import type { Error } from '../types';
import { START_WITH_LETTER_REGEXP } from '../utils/regex';

export const mustStartWithLetter =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && START_WITH_LETTER_REGEXP.test(value),
    message
  });
